import type { ReactNode } from "react";
import { Box, LinearProgress } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid";

function LoadingOverlay(): ReactNode {
  return (
    <GridOverlay sx={{ position: "relative" }}>
      <Box sx={{ position: "absolute", top: -4, width: "100%" }}>
        <LinearProgress />
      </Box>
    </GridOverlay>
  );
}

export default LoadingOverlay;
